export default {
    agentList: {
        title: "Agent List",
        serial: "No.",
        agentIdCol: "Agent ID",
        type: "Agent Type",
        tag: "Agent Tag",
        typeRequired: "Please select agent type",
        // Agent type dictionary (dict_group_item group 51001): only the three seeded
        // types are translatable; operator-created types keep their stored text via defaultValue
        typeDict: {
            "51001001": "Physical Store Promotion",
            "51001002": "Advertising Promotion",
            "51001003": "Regular Promotion",
        },
        name: "Agent Name",
        nameRequired: "Please enter agent name",
        agentCostStats:'Promotion Cost',
        account: "Agent Account",
        accountRequired: "Please enter 6-18 characters (letters and numbers)",
        accountPlaceholder: "Please enter agent account",
        domain: "Agent Domain",
        domainPlaceholder: "Please enter domain(s), separate multiple domains with commas",
        inviteCode: "Invite Code",
        inviteCodeTitle: "Agent Invite Code",
        inviteCodeType: "Invite Code Type",
        inviteCodeCustom: "Custom Invite Code",
        inviteCodeAuto: "System Generated",
        inviteCodeRequired: "Please enter invite code",
        inviteCodeRule: "Invite code must be 3-12 characters long and contain both letters and numbers",
        inviteCodePlaceholder: "Please enter 3-12 characters (letters and numbers)",
        inviteCodeExist: "This invite code already exists, please use another one",
        remark: "Remark",
        add: "Add Agent",
        addSuccess: "Added successfully",
        edit: "Edit Agent",
        editSuccess: "Updated successfully",
        delete: "Delete",
        deleteSuccess: "Deleted successfully",
        enabled: "Enabled",
        enableSuccess: "Enabled successfully",
        disabled: "Disabled",
        disableSuccess: "Disabled successfully",
        lastOpTime: "Last Operation Time",
        lastOpUser: "Last Operator",
        confirmDelete: "Are you sure you want to delete this agent?",
        confirmEnable: "Are you sure you want to enable this agent?",
        confirmDisable: "Are you sure you want to disable this agent?",
        search: "Search",
        reset: "Reset",
        all: "All",
        action: "Action",
        pagination: "Total {total} records, Page {current} / {page}",
        domainFormatError: "Only valid domains without 'http://' or 'https://' are accepted",
        accountFormatError: "Account must be 6-18 characters long and contain both letters and numbers",
      disabledKyc: "Disable registration KYC",
      confirmKycDisable: "Disable registration KYC",
      optionFalse: "Operation failed",
      confirmKycEnabled: "Enable registration KYC",
      enabledKyc: "Enable registration KYC",
      disabledWithdrawKyc: "Disable withdrawal KYC",
      confirmWithdrawKycDisable: "Disable withdrawal KYC",
      confirmWithdrawKycEnabled: "Enable withdrawal KYC",
      enabledWithdrawKyc: "Enable withdrawal KYC",
      agentLevel: "Agent Level",
      agentLevelRequired: "Please select agent level",
      agentLevelTop: "Top-level Agent",
      agentLevelSub: "Sub-level Agent",
      agentLevelTip: "Top-level = parent agent; Sub-level = normal agent (parent required)",
      parentAgent: "Parent Agent",
      parentAgentRequired: "Please select a parent agent",
      parentAgentPlaceholder: "Please select a parent agent",
      parentAgentTip: "Required when sub-level is selected",
      agentLevelLockedTip: "Agent level cannot be changed once set",
      parentAgentLockedTip: "Parent agent cannot be changed once set",
      expandSubAgents: "Expand sub-agents",
      collapseSubAgents: "Collapse sub-agents",
      loginEnable: "Enabled",
      confirmEnableLogin: "Enable login for this agent?",
      confirmEnableLoginContent: "Once enabled, this agent will be able to log in normally.",
      confirmDisableLogin: "Disable login for this agent?",
      confirmDisableLoginContent: "Once disabled, this agent will not be able to log in.",
      optionTrue: "Operation succeeded",
      loginPassword: "Login Password",
      loginPasswordRequired: "Please enter login password",
      loginPasswordPlaceholder: "≥8 chars, letters + digits",
      loginPasswordRule: "Password must be at least 8 characters and contain both letters and digits",
      loginPasswordTip: "Used by the agent on first login",
      loginPasswordEditTip: "Leave blank to keep current password; otherwise must be ≥8 chars with letters and digits",
      confirmPassword: "Confirm Password",
      confirmPasswordRequired: "Please re-enter the login password",
      confirmPasswordPlaceholder: "Please re-enter the login password",
      confirmPasswordMismatch: "The two passwords do not match"
  },
  agentStats: {
    title: "Agent Statistics",
    phpTab: "PHP",
    vndTab: "VND",
    agentType: "Agent Type",
    agentTypePlaceholder: "Please select agent type",
    agentName: "Agent Account",
    agentNamePlaceholder: "Please enter agent account",
    currency: "Currency",
    currencyPlaceholder: "Please select currency",
    sequence: "No.",
    loginUserCount: "Login Users Count",
    registerCount: "Total Registered Members",
    totalRechargeAmount: "Total Deposit Amount",
    totalWithdrawalAmount: "Total Withdrawal Amount",
    betFlow: "Valid Betting",
    gameAmount: "Platform P&L",
    cost: "Total Channel Cost",
    registerCost: "Registration Cost",
    firstRechargeCost: "First Deposit Cost",
    costTooltip: "The cumulative total value of this agent's \"cost\"",
    registerCostTooltip: "Registration Cost = Total Channel Cost / Total Registered Users",
    firstRechargeCostTooltip: "First Deposit Cost = Total Channel Cost / Total First Deposit Users",
    firstRechargeCount: "First Deposit Count",
    linkClickCount: "Link Click Count",
    activatedUserCount: "Activated Users",
    activatedDepositUserCount: "Activated Deposit Users",
    currRegisterCost: "Daily Registration Cost",
    currFirstRechargeCost: "Daily First Deposit Cost",
    currRegisterCostTooltip: "Registration Cost = Daily Cost / Daily Registered Users",
    currFirstRechargeCostTooltip: "First Deposit Cost = Daily Cost / Daily First Deposit Users",
    pleaseSearchFirst: "Please search first",
    riskCount: "Risk MemberCount",
    riskCountPercent: "Risk Member Percent",
  },
  // Agent daily game category report (FBMPLAY-1670)
  agentGameCategoryReport: {
    gameCategory: "Game Category",
    gameProvider: "Game Provider",
    memberGroup: "Member Data",
    totalMemberCount: "Total Members",
    registerCount: "New Today",
    rechargeGroup: "Deposit",
    withdrawGroup: "Withdraw",
    amountCol: "Amount",
    countCol: "Users",
    betCount: "Bets",
    betAmount: "Bet",
    payoutAmount: "Payout",
    ggr: "GGR",
    totalGroup: "Total",
    totalBonus: "Total Bonus",
    totalBet: "Total Bet",
    totalPayout: "Total Payout",
    totalGgr: "Total GGR",
    officialDirect: "Official Direct",
  },
  agentDailyStats: {
    title: "Agent Daily Performance",
    day: "Date",
    agentType: "Agent Type",
    agentName: "Agent Account",
    agentNamePlaceholder: "Please enter agent account",
    loginUserCount: "Login Users Count",
    registerCount: "Register Count",
    firstRechargeCount: "First Deposit Count",
    firstDepositAmount: "First Deposit Amount",
    rechargeCount: "Deposit Count",
    rechargeAmount: "Deposit Amount",
    linkClickCount: "Link Click Count",
    activatedUserCount: "Activated Users",
    activatedDepositUserCount: "Activated Deposit Users",
    withdrawalCount: "Withdrawal Count",
    withdrawalAmount: "Withdrawal Amount",
    betFlow: "Valid Betting",
    gameAmount: "Platform P&L",
    betAmount: "Bet Amount",
    payoutAmount: "Payout Amount",
    ggr: "GGR",
    netAmount: "Deposit/Withdrawal Profit & Loss",
    pleaseSearchFirst: "Please search first"
  },
  agentCostStats: {
    title: "Promotion Cost",
    day: "Date",
    agentType: "Agent Type",
    agentName: "Agent Account",
    agentNamePlaceholder: "Please enter agent name",
    registerCount: "Register Count",
    rechargeCount: "Deposit Count",
    rechargeAmount: "Deposit Amount",
    withdrawalCount: "Withdrawal Count",
    withdrawalAmount: "Withdrawal Amount",
    profit: "Profit/Loss",
    cost: "Cost",
    returnRate: "Cost Return Rate",
    paybackDays: "Payback Days",
    action: "Action",
    editCost: "Cost",
    editCostModalTitle: "Edit Cost",
    costLabel: "Cost Amount",
    costPlaceholder: "Please enter cost amount",
    costRequired: "Please enter cost amount",
    costMinValue: "Cost amount cannot be less than 0",
    updateCostSuccess: "Cost updated successfully",
    pleaseSearchFirst: "Please search first",
    dateRangeExceeds31Days: "Date range cannot exceed 31 days"
  },
  agentTodayData: {
    title: "Today's Agent Data",
    levelTop: "Top",
    levelSub: "Sub",
    levelSelf: "Direct",
    aggregatedSuffix: "(Total)",
    agentAccount: 'Agent Account',
    search: 'Search',
    pleaseEnterAgentAccount: 'Please enter agent account',
    agentAccountNotFound: 'The agent account you entered does not exist, please re-enter',
    noData: 'No data, please search for an agent first',
    registerCount: 'Registered Users',
    firstRechargeCount: 'First Deposit Users',
    rechargeCount: 'Deposit Users',
    withdrawalCount: 'Withdrawal Users',
    profit: 'Deposit/Withdrawal P&L',
    firstRechargeAmount: 'First Deposit Amount',
    rechargeAmount: 'Deposit Amount',
    withdrawalAmount: 'Withdrawal Amount',
    agentAccountDigitsOnly: 'Agent account can only contain digits',
  },
  agentTag: {
    title: "Agent Tag",
    serial: "No.",
    tagName: "Tag Name",
    tagNameRequired: "Please enter tag name",
    tagNamePlaceholder: "Please enter",
    remark: "Remark",
    remarkPlaceholder: "Please enter",
    lastOpTime: "Last Operation Time",
    lastOpUser: "Last Operator",
    action: "Action",
    add: "Add Agent Tag",
    addSuccess: "Added successfully",
    edit: "Edit",
    editSuccess: "Updated successfully",
    delete: "Delete",
    deleteSuccess: "Deleted successfully",
    confirmDelete: "Are you sure you want to delete this tag?",
    search: "Search",
    reset: "Reset",
    pagination: "Total {total} records, Page {current} / {page}",
  },
  agentTransfer: {
    // Top tabs
    tab_transfer: "Agent Transfer",
    tab_history: "Transfer Records",
    tab_game_category: "Agent Daily Game Category Report",
    // Sidebar (AgentTreeSidebar)
    sidebar_search_placeholder: "Search agent account",
    sidebar_empty: "No agents",
    sidebar_tag_l1: "L1",
    sidebar_tag_l2: "L2",
    sidebar_subagent_count_tooltip: "{count} sub-agents",
    sidebar_loading: "Loading…",
    sidebar_no_subagents: "No sub-agents",
    // Empty states
    empty_select_l1: "Please select a top-level (L1) agent from the left",
    empty_select_l2: "Please select a sub-level (L2) agent from the left",
    // L1 panel (AgentTransferTab)
    tag_top_agent: "Top-level Agent",
    tag_sub_agent: "Sub-level Agent",
    stat_sub_count: "Sub-agents",
    stat_direct_member: "Direct members",
    btn_demote_to_l2: "Demote to L2",
    card_subagent_list: "Sub-agents",
    col_agent_account: "Agent Account",
    col_agent_name: "Agent Name",
    col_action: "Action",
    btn_transfer: "Transfer",
    empty_no_subagent_for_l1: "This L1 agent has no sub-agents",
    member_count_unit_suffix: "",
    card_direct_member: "Direct members",
    card_recent_log: "Recent transfer records",
    btn_view_all_log: "View all records",
    no_recent_log: "No records",
    log_upgrade_text: "{account} upgraded from L2 to L1",
    log_demote_text: "{account} demoted from L1 to L2, attached to {target}",
    log_transfer_text: "{account} moved from {from} → {to}",
    // Demote blocker
    demote_blocked_title: "Cannot demote directly",
    demote_blocked_line1: "This L1 agent still has {count} sub-agents and cannot be demoted directly.",
    demote_blocked_line2: "Please transfer the sub-agents to another L1 agent first, then perform the demote.",
    // SubAgentDetailPanel
    sub_panel_parent_l1: "Parent L1: ",
    sub_panel_member_count: "Direct members",
    btn_transfer_to_other_l1: "Transfer to another L1",
    btn_upgrade_to_l1: "Upgrade to L1",
    // AgentMemberListCard
    member_card_title_default: "Direct members",
    member_col_account: "Member Account",
    member_col_vip: "VIP Level",
    member_col_deposit: "Total Deposit",
    member_col_last_login: "Last Login",
    member_col_status: "Status",
    member_status_active: "Active",
    member_status_inactive: "Inactive",
    member_empty: "This agent has no direct members",
    member_total: "{total} rows",
    member_load_fail: "Failed to load member list",
    // TransferSubAgentModal
    transfer_modal_title: "Transfer Sub-Agent",
    transfer_modal_ok: "Confirm Transfer",
    modal_cancel: "Cancel",
    modal_label_account: "Agent Account: ",
    modal_label_name: "Agent Name: ",
    modal_label_current_parent: "Current Parent: ",
    modal_label_member_count: "Direct Members: ",
    transfer_info_member_count: "Direct members",
    transfer_info_follow: "All will follow the transfer to the target L1",
    transfer_field_target: "Target L1 Agent",
    transfer_field_target_required: "Please select the target L1 agent",
    transfer_field_target_placeholder: "Please select the target L1 agent",
    transfer_field_reason: "Transfer Reason",
    transfer_field_reason_required: "Please enter the transfer reason",
    transfer_field_reason_placeholder: "Please enter the transfer reason",
    transfer_impact_title: "Impact after transfer:",
    transfer_impact_1: "1. This sub-agent is moved under the target L1; its direct members remain attached to this sub-agent.",
    transfer_impact_2_a: "2. Members' direct agent does not change — only the upstream L1 changes from \"",
    transfer_impact_2_b: "\" to the target L1.",
    transfer_impact_3: "3. Historical betting / deposit / withdrawal records keep their original attribution and will not be retroactively updated.",
    transfer_impact_4: "4. New data generated after the transfer will be counted under the new attribution.",
    transfer_impact_5: "5. Roll-up data (registrations, deposits, withdrawals, valid bets, P&L) for both the original and target L1 will be recalculated.",
    transfer_alert: "All direct members will follow the transfer · No member will be left orphaned or duplicated · This action cannot be undone",
    // UpgradeSubAgentModal
    upgrade_modal_title: "Upgrade to L1 Agent",
    upgrade_modal_ok: "Confirm Upgrade",
    upgrade_current: "Current: ",
    upgrade_info_follow: "All will follow as direct members under the new L1",
    upgrade_impact_title: "Impact after upgrade:",
    upgrade_impact_1: "1. This agent's level changes from L2 to L1, leaving the management of the original L1 and becoming an independent L1.",
    upgrade_impact_2_bold: "All direct members will follow",
    upgrade_impact_2_post: ", changing from \"L2 direct members\" to \"new L1 direct members\".",
    upgrade_impact_3: "3. Members' parent agent does not change (still the same agent); only the agent's level is raised.",
    upgrade_impact_4: "4. Invite code stays unchanged; new privilege gained: agent domain configuration.",
    upgrade_impact_5: "5. Roll-up data (registrations, deposits, withdrawals, valid bets, P&L) for the original L1 will be fully recalculated.",
    upgrade_impact_note: "No conflicts will occur: the member's parent agent does not change — only the agent's tier is upgraded.",
    upgrade_field_reason: "Upgrade Reason",
    upgrade_field_reason_required: "Please enter the upgrade reason",
    upgrade_field_reason_placeholder: "e.g. business expansion, independent operation, etc.",
    upgrade_success_alert_prefix: "✅ Becomes an independent L1 agent · All direct members follow · Invite code preserved · Agent domain config newly available · ",
    upgrade_success_alert_bold: "This action cannot be undone",
    // DemoteTopAgentModal
    demote_modal_title: "Demote to L2 Agent",
    demote_modal_ok: "Confirm Demote",
    demote_label_current: "Current Agent: ",
    demote_label_current_tier: "Current Tier: ",
    demote_label_after_tier: "After Demote: ",
    demote_field_new_parent: "New Parent L1 Agent",
    demote_field_new_parent_required: "Please select the new parent L1 agent",
    demote_field_new_parent_placeholder: "Select which L1 agent to attach to after demotion",
    demote_field_reason: "Demote Reason",
    demote_field_reason_required: "Please enter the demote reason",
    demote_field_reason_placeholder: "Please enter the demote reason",
    demote_impact_title: "Impact after demotion:",
    demote_impact_1: "1. The agent's tier changes from \"L1\" to \"L2\", attached under the target L1 agent.",
    demote_impact_2: "2. The agent's existing direct members keep their attribution (auto-follow).",
    demote_impact_3: "3. Invite code and agent domain remain unchanged; new members can still register via the original channel.",
    demote_impact_4: "4. Historical betting / deposit / withdrawal records keep their original attribution and will not be retroactively updated.",
    demote_alert: "This action cannot be undone · After demotion, the agent will no longer accept new L2 agents as an L1 · To restore, please contact the administrator.",
    // Page-level messages
    msg_load_agent_list_fail: "Failed to load agent list",
    msg_load_subagent_fail: "Failed to load sub-agent list",
    msg_transfer_success: "{account} has been transferred to {target}",
    msg_transfer_fail: "Transfer failed",
    msg_upgrade_success: "{account} has been upgraded to an L1 agent",
    msg_upgrade_fail: "Upgrade failed",
    msg_demote_success: "{account} has been demoted and attached to {target}",
    msg_demote_fail: "Demote failed",
  },
  transferLog: {
    related_top_agent: "Related L1 Agent",
    related_top_agent_hint: "(Only showing transfer / demote / upgrade records related to this L1 agent)",
    filter_transfer_type: "Operation Type",
    filter_transfer_type_placeholder: "All",
    filter_agent_account: "Agent Account",
    filter_agent_account_placeholder: "Target agent",
    filter_from_parent: "From L1",
    filter_from_parent_placeholder: "Original L1 account",
    filter_to_parent: "To L1",
    filter_to_parent_placeholder: "New L1 account",
    filter_date_range: "Operation Time",
    search: "Search",
    reset: "Reset",
    query_fail: "Query failed",
    type_transfer: "Transfer",
    type_demote: "Demote",
    type_upgrade: "Upgrade",
    col_record_id: "Record ID",
    col_transfer_type: "Operation",
    col_agent_account: "Agent Account",
    col_from: "From",
    col_to: "To",
    col_reason: "Reason",
    col_operator: "Operator",
    col_create_time: "Operation Time",
    tier_l1: "L1",
    tier_l2: "L2",
    total: "{total} rows",
  },
  agentType: {
    title: "Agent Type",
    serial: "No.",
    typeName: "Type Name",
    typeNameRequired: "Please enter type name",
    typeNamePlaceholder: "Please enter",
    typeDesc: "Type Description",
    typeDescRequired: "Please enter type description",
    typeDescPlaceholder: "Please enter",
    lastOpTime: "Last Operation Time",
    lastOpUser: "Last Operator",
    action: "Action",
    add: "Add",
    addSuccess: "Added successfully",
    edit: "Edit",
    editSuccess: "Updated successfully",
    delete: "Delete",
    deleteSuccess: "Deleted successfully",
    confirmDelete: "Are you sure you want to delete this type?",
    search: "Search",
    reset: "Reset",
    pagination: "Total {total} records, Page {current} / {page}",
  }
};
